module.exports = __webpack_public_path__ + "img/ic_boy (1).d4ec3b97.png";